<div *ngIf="phxAddOnBefore" class="phx-add-on phx-add-on-before">
  <ng-container [ngTemplateOutlet]="phxAddOnBefore"></ng-container>
</div>

<div
  class="phx-input-group-content"
  [ngClass]="{
    'phx-input-disabled': disabled,
    'phx-input-default': style === 'default',
    'phx-input-borderless': style === 'borderless',
    'phx-input-underline': style === 'underline',
    'phx-has-value': phxHasValue,
    'phx-input-group-error': (phxFormError && hasBeenTouched) || phxIsInvalid
  }"
  (click)="focusInput()"
>
  <span *ngIf="phxPrefix" class="phx-prefix">
    <ng-container [ngTemplateOutlet]="phxPrefix"></ng-container>
  </span>
  <ng-content></ng-content>
  <span *ngIf="phxSuffix" class="phx-suffix">
    <ng-container [ngTemplateOutlet]="phxSuffix"></ng-container>
  </span>
</div>

<div *ngIf="phxAddOnAfter" class="phx-add-on phx-add-on-after">
  <ng-container [ngTemplateOutlet]="phxAddOnAfter"></ng-container>
</div>
